import styled, { css } from 'styled-components';

export const Table = styled.div<{
  $reversed?: boolean;
  $plain?: boolean;
  $noPadding?: boolean;
}>`
  border: 1px solid var(--v3-black-2);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
  color: var(--v3-text-color-secondary);

  ${({ $noPadding }) =>
    $noPadding &&
    css`
      padding: 0;
    `}

  ${({ $plain }) =>
    $plain &&
    css`
      border: unset;
      border-radius: unset;
      margin-bottom: unset;
    `}
  > div {
    display: flex;
    justify-content: space-between;
    :not(:last-child) {
      border-bottom: 1px solid var(--v3-black-2);
      > p {
        margin-bottom: 12px;
      }
    }
    ${({ $reversed }) =>
      $reversed
        ? css`
            :first-child {
              > p:last-child {
                font-size: 20px;
                font-weight: 700;
                color: var(--v3-primary-color);
              }
            }
          `
        : css`
            :last-child {
              > p:last-child {
                font-size: 20px;
                font-weight: 700;
                color: var(--v3-primary-color);
              }
            }
          `}
    :not(:first-child) {
      > p {
        margin-top: 16px;
      }
    }
    > p {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      :last-child {
        font-size: 16px;
        line-height: 20px;
        color: var(--v3-text-color);
      }
    }
  }
`;
